import { render, staticRenderFns } from "./ShopifyDeactivatedStore.vue?vue&type=template&id=19653c37&scoped=true&"
import script from "./ShopifyDeactivatedStore.vue?vue&type=script&lang=ts&"
export * from "./ShopifyDeactivatedStore.vue?vue&type=script&lang=ts&"
import style0 from "./ShopifyDeactivatedStore.vue?vue&type=style&index=0&id=19653c37&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19653c37",
  null
  
)

export default component.exports